import React, { useContext, useEffect } from "react";
import AnimationRevealPage from "helpers/AnimationRevealPage.js";
import VisitorHeader from "components/headers/VisitorHeader.js";
import VisitorCards from "components/cards/VisitorCards.js";
import { AppContext } from "components/context/AppContext";
import Faq from "components/faqs/SimpleWithSideImage.js";
import Footer from "components/footers/MiniCenteredFooter.js";
import { NotificationContainer, NotificationManager } from "react-notifications";
import { useVisitors } from "hooks/useVisitors";
import styled from "styled-components";
import LoadingSpinner from "components/misc/LoadingSpinner.js";
import { ROUTE_PATHS } from "utils/routes";
import { ReactComponent as StarIcon } from "feather-icons/dist/icons/star.svg";

const NewVisitSection = styled.div`
  display: flex;
  /* 1. CORRECCIÓN: Flujo vertical en móvil, fila en pantallas de 640px en adelante */
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  
  @media (min-width: 640px) {
    flex-direction: row;
    align-items: center;
    justify-content: flex-start;
    text-align: left;
  }

  background: linear-gradient(90deg, #e0efffff 0%, #fff 100%);
  border-radius: 24px;
  box-shadow: 0 4px 24px rgba(0,0,0,0.07);
  
  /* 2. CORRECCIÓN: Evitamos paddings asimétricos o nulos en móvil */
  padding: 1.5rem;
  margin: 2.5rem 0 1.5rem 0;
  align-self: flex-start;
  width: 100%;
  box-sizing: border-box;

  @media (min-width: 640px) {
    padding: 2rem 2.5rem 2rem 1.5rem;
  }
`;

const NewVisitImage = styled.img`
  /* 3. CORRECCIÓN: Imagen un poco más pequeña en móvil para que no asfixie el diseño */
  width: 100px;
  height: 100px;
  object-fit: cover;
  border-radius: 16px;
  margin-right: 0;
  margin-bottom: 1.5rem;
  box-shadow: 0 2px 12px rgba(0,0,0,0.10);

  @media (min-width: 640px) {
    width: 120px;
    height: 120px;
    margin-right: 2rem;
    margin-bottom: 0;
  }
`;

const NewVisitContent = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center; /* Centrado en móvil */
  width: 100%;

  @media (min-width: 640px) {
    align-items: flex-start; /* Alineado a la izquierda en pantallas más grandes */
  }
`;

const NewVisitTitle = styled.h2`
  /* 4. CORRECCIÓN: Tipografía responsiva escalable */
  font-size: 1.5rem;
  font-weight: 700;
  color: #2d3748;
  margin-bottom: 0.5rem;

  @media (min-width: 640px) {
    font-size: 2rem;
  }
`;

const NewVisitDesc = styled.p`
  /* 5. CORRECCIÓN: Reducción leve de tamaño y espaciado de texto */
  font-size: 0.95rem;
  color: #4a5568;
  margin-bottom: 1.2rem;
  line-height: 1.5;

  @media (min-width: 640px) {
    font-size: 1.1rem;
  }
`;

const NewVisitButton = styled.button`
  background: linear-gradient(90deg, #4299e180 0%, #072448ff 100%);
  color: #fff;
  font-size: 1rem;
  font-weight: 600;
  
  /* 6. CORRECCIÓN: Forzamos ancho total fluido en móvil y un padding horizontal menor para que no desborde */
  width: 100%;
  padding: 0.8rem 1.5rem;
  
  @media (min-width: 640px) {
    width: auto;
    font-size: 1.1rem;
    padding: 0.8rem 2.2rem;
  }

  border: none;
  border-radius: 12px;
  box-shadow: 0 2px 8px rgba(99,102,241,0.15);
  cursor: pointer;
  transition: background 0.2s, transform 0.2s;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  text-align: center;
  box-sizing: border-box;

  &:hover {
    background: linear-gradient(90deg, #4299e180 0%, #0e6cdeff 100%);
    transform: translateY(-2px) scale(1.04);
  }
`;


const SpinnerOverlay = styled.div`
  position: fixed;
  top: 0; left: 0;
  width: 100vw; height: 100vh;
  background: rgba(255,255,255,0.7);
  z-index: 9999;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export default () => {
  const { state } = useContext(AppContext);
  const appBaseUrl = process.env.REACT_APP_BASE_URL;
  const { fetchVisitors, loading } = useVisitors();

  useEffect(() => {
    const fetchVisitors = async () => {
      // Only fetch visitors for users with homeowner data
      if (state.user?.homeowner?.homeownerId) {
        await getVisitorsData(state.user.homeowner.homeownerId);
      }
    };

    fetchVisitors();
  }, []);

  const visitorCards = []
  if (state.visitors.length > 0) {
    state.visitors.filter(visitor => visitor.invitationStatusId === 3).forEach(visitor => {
      // Use the new GUID-based invitation URL (no sequential integer IDs in URLs — OWASP IDOR)
      const invitationUrl = `${appBaseUrl}invitacion/${visitor.guid}`;
      const visitorCard = {
        id: visitor.visitorId.toString(),
        title: visitor.visitorName,
        description: visitor.visitReason + " agendada del " + visitor.startDate + " al " + visitor.endDate,
        locationText: visitor.homeowner.suburb.suburbName + " #" + visitor.homeowner.homeNumber,
        rating: "Activo",
        deleteText: "Cancelar",
        url: invitationUrl,
        // wa.me deep link — homeowner shares from their own personal WhatsApp (no API cost)
        waLink: `https://wa.me/${visitor.visitorPhoneNumber}?text=${encodeURIComponent(`¡Hola ${visitor.visitorName}! Aquí está tu link de acceso personal al fraccionamiento (NO compartir): ${invitationUrl}`)}`,
        message : `¡Hola ${visitor.visitorName}! Aquí está tu link de acceso personal al fraccionamiento (NO compartir): ${invitationUrl}`,
        phone: visitor.visitorPhoneNumber,
      };

      visitorCards.push(visitorCard);
    });
  }

  const pendingVisitorCards = []
  if (state.visitors.length > 0) {
    state.visitors.filter(visitor => visitor.invitationStatusId === 1 || visitor.invitationStatusId === 4).forEach(visitor => {
      const invitationUrl = `${appBaseUrl}invitacion/${visitor.guid}`;
      const visitorCard = {
        id: visitor.visitorId.toString(),
        title: visitor.visitorName,
        description: visitor.visitReason + " agendada del " + visitor.startDate + " al " + visitor.endDate,
        locationText: visitor.homeowner.suburb.suburbName + " #" + visitor.homeowner.homeNumber,
        rating: "Pendiente",
        deleteText: "Cancelar",
        url: invitationUrl,
        waLink: `https://wa.me/${visitor.visitorPhoneNumber}?text=${encodeURIComponent(`¡Hola ${visitor.visitorName}! Aquí está tu link de acceso personal al fraccionamiento (NO compartir): ${invitationUrl}`)}`,
        message : `¡Hola ${visitor.visitorName}! Aquí está tu link de acceso personal al fraccionamiento (NO compartir): ${invitationUrl}`,
        phone: visitor.visitorPhoneNumber,
      };

      pendingVisitorCards.push(visitorCard);
    });
  }

  const getVisitorsData = async (id) => {
    await fetchVisitors(id).then((response) => {
      if (response.data.visitors.length > 0) {
        // Do something with the visitors data
        console.log("Visitors data fetched successfully.");
      }
    }).catch((error) => {
      console.log("Failed to get visitors: " + error);
      NotificationManager.error(error.message, "Error al mostrar Invitaciones", 5000);
    });
  };

  return (
    <>
      {loading && (
        <SpinnerOverlay>
          <LoadingSpinner text="Cargando tus invitaciones…" />
        </SpinnerOverlay>
      )}
      {!loading && (
        <AnimationRevealPage>
          <VisitorHeader />
          {/* New Visit Section */}
          <NewVisitSection>
            <NewVisitImage src={require("../images/demo/visitor-page.png")} alt="Nueva visita" />
            <NewVisitContent>
              <NewVisitTitle>Registrar nueva visita</NewVisitTitle>
              <NewVisitDesc>Genera una invitación con QR dinámico anti-fraude. El código caduca cada 30 segundos — nadie más puede usarlo aunque lo compartan.</NewVisitDesc>
              <NewVisitButton onClick={() => window.location.href = ROUTE_PATHS.VISITREGISTER}>
                <span>Crear invitación</span>
                <StarIcon style={{width: "1.5em", height: "1.5em", marginRight: 8, color: "#FFD700", fill: "#FFD700"}} />
              </NewVisitButton>
            </NewVisitContent>
          </NewVisitSection>
          {/*<Features />*/}
          <h2 style={{fontSize: '1.7rem', fontWeight: 700, color: '#2d3748', margin: '2rem 0 0.5rem 0'}}>✅ Invitaciones Confirmadas</h2>
          <p style={{color: '#718096', marginBottom: '1rem', fontSize: '0.95rem'}}>Visitas con QR activo — comparte el enlace directamente con tu visitante por WhatsApp.</p>
          {/* <div style={{display: 'flex', flexWrap: 'wrap', gap: '2rem', justifyContent: 'center'}}>
            <VisitorCards title="Confirmados" visitorCards={visitorCards || []} Icon="StarIcon" getVisitors={() => getVisitorsData(state.user.homeownerId)} />
          </div> */}
          <VisitorCards title="Confirmados" visitorCards={visitorCards || []} Icon="StarIcon" getVisitors={() => getVisitorsData(state.user.homeownerId)} />
          <h2 style={{fontSize: '1.7rem', fontWeight: 700, color: '#2d3748', margin: '2rem 0 0.5rem 0'}}>⏳ Invitaciones ⏳ Invitaciones Pendientes</h2>
          <p style={{color: '#718096', marginBottom: '1rem', fontSize: '0.95rem'}}>El visitante aún no ha activado su QR. Comparte el enlace para que complete la verificación.</p>
          {/* <div style={{display: 'flex', flexWrap: 'wrap', gap: '2rem', justifyContent: 'center'}}>
            <VisitorCards title="Pendientes" visitorCards={pendingVisitorCards || []} Icon="WarningIcon" getVisitors={() => getVisitorsData(state.user.homeownerId)} />
          </div> */}
          <VisitorCards title="Pendientes" visitorCards={pendingVisitorCards || []} Icon="WarningIcon" getVisitors={() => getVisitorsData(state.user.homeownerId)} />
          {/*<TrendingCard />*/}
          {/*<MainFeature />*/}
          {/*<Blog />*/}
          {/*<Testimonial textOnLeft={true}/>*/}
          <Faq />
          {/*<SubscribeNewsLetterForm />*/}
          <Footer />
        </AnimationRevealPage>
      )}
      <NotificationContainer />
    </>
  )
};
